import { render, staticRenderFns } from "./CollectionTaskCompleted.vue?vue&type=template&id=2da8cf60&scoped=true&"
import script from "./CollectionTaskCompleted.vue?vue&type=script&lang=js&"
export * from "./CollectionTaskCompleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da8cf60",
  null
  
)

export default component.exports